import { useQuery } from '@apollo/client';
import { useCallback } from 'react';
import { GET_SCENARIOS_BASIC_DETAILS } from '../../../../graphql/ActionPlanning.queries';
import { getScenarioNames } from '../utils';

export const useQueryGetScenariosBasicDetails = () => {
  const { data: scenarios } = useQuery(GET_SCENARIOS_BASIC_DETAILS);

  const scenarioNames = useCallback(
    (scenarioId?: number) => getScenarioNames(scenarios?.scenario, scenarioId),
    [scenarios],
  );

  return {
    scenarioNames,
  };
};
